<template>
  <v-overlay :model-value="overlay" class="align-center justify-center">
    <v-progress-circular
      style="color: rgba(21, 102, 124, 0.9)"
      indeterminate
      size="64"
    ></v-progress-circular>
  </v-overlay>
  <v-layout>
    <Header v-on:studyChange="selectStudy"></Header>
    <v-main>
      <v-row v-if="flag" style="margin: 2px 2px 0px; height: 800px">
        <p style="margin-left: auto; margin-right: auto">
          No Case Assignment option for this study
        </p>
      </v-row>
      <v-row
        v-if="!flag"
        no-gutters
        style="
          border-bottom: rgb(21 72 124) solid 2px;
          border-left: 2px solid rgb(21 72 124);
        "
      >
        <v-col sm="12" md="6" lg="8">
          <v-sheet
            color="green-lighten-3"
            height="800"
            w-100
            variant="outlined"
          >
            <AssignmentLeafletMap
              :mapId="assignMapId"
              :isFullScreen="isFullScreen"
              :staffName="selectedStaffId"
              :study="studyCode"
              :mapMsg="assignMapMsg"
              :displayLoader="loading"
            >
            </AssignmentLeafletMap>
          </v-sheet>
        </v-col>
        <v-col md="6" lg="4">
          <div style="height: 205px">
            <v-row
              variant="outlined"
              no-gutters
              style="
                border-right: 2px solid rgb(21 72 124);
                border-bottom: 2px solid rgb(21 72 124);
                background: linear-gradient(
                  0.25turn,
                  #f8f8ff,
                  #e0e0e0,
                  #f8f8ff
                );
                background: linear-gradient(
                  0.25turn,
                  rgb(248, 248, 255),
                  rgb(224, 224, 224),
                  rgb(248, 248, 255)
                );
              "
            >
              <span style="font-size: 20px; padding-left: 5px"
                >Region {{ region }} Summary</span
              >
              <v-spacer></v-spacer>
              <v-dialog
                v-model="dialog"
                persistent
                max-width="600px"
                style="z-index: 1000"
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    color="rgb(21 72 124)"
                    density="compact"
                    text="confirm region"
                    v-bind="props"
                    height="24"
                    width="210"
                    style="
                      float: left;
                      background: white;
                      border: 2px solid rgb(21 72 124);
                      margin: 2px;
                    "
                    variant="outlined"
                  >
                  </v-btn>
                </template>
                <v-card justify="center">
                  <v-card-title>
                    Are you sure you want to confirm all cases for Region
                    {{ this.region }}?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="rgb(21 72 124)" text @click="dialog = false">
                      Close
                    </v-btn>
                    <v-btn
                      color="rgb(21 72 124)"
                      dark
                      v-if="allowConfirm"
                      class="ma-2"
                      :loading="loading"
                      :disabled="loading"
                      @click="
                        confirmRegion();
                        loading = true;
                        dialog = false;
                      "
                    >
                      Confirm
                      <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                      </template>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row
              no-gutters
              style="
                border-bottom: 2px solid rgb(21 72 124);
                border-right: 2px solid rgb(21 72 124);
              "
            >
              <RegionSummaryTable
                :summary="regionTables[this.region]"
              ></RegionSummaryTable>
            </v-row>
            <v-row
              variant="outlined"
              no-gutters
              style="
                border-right: 2px solid rgb(21 72 124);
                border-bottom: 2px solid rgb(21 72 124);
                background: linear-gradient(
                  0.25turn,
                  rgb(248, 248, 255),
                  rgb(224, 224, 224),
                  rgb(248, 248, 255)
                );
              "
            >
              <span class="cardText"
                >{{ assignStaffId || "Staff" }}
                {{ assignStaffName || "Name" }}</span
              >
              <v-spacer></v-spacer>
              <v-dialog
                v-model="dialogInterviewer"
                persistent
                max-width="600px"
                style="z-index: 1000"
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    color="rgb(21 72 124)"
                    dark
                    v-bind="props"
                    height="24"
                    width="210"
                    style="
                      float: left;
                      background: white;
                      border: 2px solid rgb(21 72 124);
                      margin: 2px;
                    "
                    variant="outlined"
                    text="Confirm Staff"
                  >
                  </v-btn>
                </template>
                <v-card justify="center">
                  <v-card-title center>
                    Are you sure you want to confirm all cases for
                    {{ this.assignStaffId }}?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="rgb(21 72 124)"
                      text
                      @click="dialogInterviewer = false"
                    >
                      Close
                    </v-btn>
                    <v-btn
                      color="rgb(21 72 124)"
                      dark
                      v-if="allowConfirm"
                      class="ma-2"
                      :loading="loading"
                      :disabled="loading"
                      @click="
                        confirmInterviewer();
                        loading = true;
                        dialogInterviewer = false;
                      "
                    >
                      Confirm
                      <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                      </template>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row no-gutters
              ><ag-grid-vue
                style="
                  height: 624px;
                  width: 100%;
                  font-size: 16px;
                  border-right: 2px solid rgb(21 72 124);
                "
                class="ag-theme-balham center-box elevation-2 caseAssignmentGrid"
                :columnDefs="rightColumnDefs"
                :rowData="dailyTasksData"
                :gridOptions="gridOptionsCases"
                :enableCellChangeFlash="true"
                :rowSelection="rowSelection"
                @grid-ready="onGridReady"
                rowHeight="30"
              ></ag-grid-vue>
              <div
                id="statusPopover"
                class="popover-content"
                v-bind:class="{
                  show: showStatusPopover,
                  hide: !showStatusPopover,
                }"
              >
                <StatusPopup
                  :studyCode="studyCode"
                  :record="record"
                  :assignStaffId="assignStaffId"
                  :region="region"
                  @refreshData="refreshData"
                  @close="showStatusPopover = false"
                ></StatusPopup>
              </div>
							<div
                id="notesPopover"
                class="popover-content"
                v-bind:class="{
                  show: showNotesPopover,
                  hide: !showNotesPopover,
                }"
              >
                <CommentsPopup
									:record="record"
									:caseCommentsList="caseCommentsList"
                  @close="showNotesPopover = false"
									@refreshData="refreshData"
                ></CommentsPopup>
              </div>
							<div
								v-if="showMultipleStatusPopover"
								id="multipleStatusPopover"
                class="popover-content"
                v-bind:class="{
                  show: showMultipleStatusPopover,
                  hide: !showMultipleStatusPopover,
                }"
              >
                <MultipleStatusPopUp
								:studyCode="studyCode"
								:multipleRecords="selectedRegionCases"
                :region="region"
                @close="showMultipleStatusPopover = false"
								@refreshData="refreshData"
                ></MultipleStatusPopUp>
							</div>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-if="!flag"
        no-gutters
        style="
          height: 50px;
          border-bottom: 2px solid rgb(41, 114, 134);
          border-right: 2px solid rgb(41, 114, 134);
          border-left: 2px solid rgb(41, 114, 134);
          background: linear-gradient(
            0.25turn,
            rgb(248, 248, 255),
            rgb(224, 224, 224),
            rgb(248, 248, 255)
          );
        "
      >
        <div
          class="searchTitle"
          style="margin-left: 10px; margin-right: 10px; color: rgb(21 72 124)"
        >
          REGION:
        </div>
        <v-select
          v-model="region"
          :items="regionList"
          density="compact"
          variant="outlined"
          bg-color="white"
          style="z-index: 1000; max-width: 100px; padding-top: 2px"
        ></v-select>
      </v-row>
      <v-row
        v-if="!flag"
        no-gutters
        style="
          border-right: 2px solid rgb(21 72 124);
          border-left: 2px solid rgb(21 72 124);
          border-bottom: 2px solid rgb(21 72 124);
        "
      >
        <ag-grid-vue
          style="height: 400px; width: 100%; font-size: 16px"
          class="ag-theme-balham center-box elevation-2 caseAssignmentGrid"
          :columnDefs="bottomColumnDefs"
          :rowData="allStaffData"
          :gridOptions="gridOptions"
          :rowSelection="rowSelection"
          :enableCellChangeFlash="true"
          @selection-changed="onSelectionChanged"
          @grid-ready="onGridReady"
          pagination="true"
          rowHeight="30"
        ></ag-grid-vue>
      </v-row>
    </v-main>
  </v-layout>
  <!-- <v-layout wrap>
    <v-flex xs12>
			<Header v-on:studyChange="selectStudy"></Header>
			<v-row v-if="flag" style="margin: 2px 2px 0px; height: 800px">

						<p style="margin-left: auto; margin-right: auto;">No Case Assignment option for this study</p>

			</v-row>
      <v-row id="firstRow" v-if="!flag" style="margin: 2px 2px 0px;">
        <v-col cols="12" md="6" lg="7" xl="9" class="marginZeroPaddingZero" >
          <div style="position: relative;min-height: 700px;" v-status-clicked-info-popup="onUpdateStatus" v-comments-clicked-info-popup="onUpdateComments">
            <div id="mapLoader" class="maploadernoshow">
              <div class="bottom-right">
                <div class="clock"></div>
              </div>
            </div>
            <AssignmentLeafletMap
                :mapId = "assignMapId"
                :isFullScreen = "isFullScreen"
                :staffName = "selectedStaffId"
                :study = "studyCode"
                :mapMsg = "assignMapMsg"
                :displayLoader = "loading">
            </AssignmentLeafletMap>
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="5" xl="3" class="marginZeroPaddingZero">
          <div id="dailyTasksLoader"></div>
          <v-card tile id="regionSummaryCard" style="height: 172px;" >
            <v-app-bar dense flat dark color="rgb(21 72 124)" height=30>
							<span class="cardText">Region {{ region }} Summary</span>
              <v-spacer></v-spacer>
              <v-dialog
                v-model="dialog"
                persistent
                max-width="600px"
                style="z-index: 1000"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="rgb(21 72 124)"
                    dark
                    v-bind="attrs"
                    v-on="on"
										height="24"
										width="210"
										style="border-style: solid; border-width: 1px; border-color: white;"
                  >
									<span class="cardText">Confirm Region</span>
                  </v-btn>
                </template>
                <v-card justify="center">
                  <v-card-title>
                    Are you sure you want to confirm all cases for Region
                    {{ this.region }}?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="rgb(21 72 124)" text @click="dialog = false">
                      Close
                    </v-btn>
                    <v-btn
                      color="rgb(21 72 124)"
                      dark
                      v-if="allowConfirm"
                      class="ma-2"
                      :loading="loading"
                      :disabled="loading"
                      @click="
                        confirmRegion();
                        loading = true;
                        dialog = false;
                      "
                    >
                      Confirm
                      <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                      </template>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-app-bar>
            <v-card-text>
              <RegionSummaryTable
                :summary="regionTables[this.region]"
              ></RegionSummaryTable>
            </v-card-text>
          </v-card>
          <v-card tile id="staffCard">
            <v-app-bar dense flat color="rgb(21 72 124)" dark height=30>
							<span class="cardText">{{ assignStaffId || 'Staff' }} {{ assignStaffName || 'Name'}}</span>
							<v-spacer></v-spacer>
							<v-dialog
                v-model="dialogInterviewer"
                persistent
                max-width="600px"
                style="z-index: 1000"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="rgb(21 72 124)"
                    dark
                    v-bind="attrs"
                    v-on="on"
										height="24"
										width="210"
										style="border-style: solid; border-width: 1px; border-color: white;"
                  >
									<span class="cardText">Confirm Staff</span>
                  </v-btn>
                </template>
                <v-card justify="center">
                  <v-card-title center>
                    Are you sure you want to confirm all cases for {{ this.assignStaffId }}?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="rgb(21 72 124)" text @click="dialogInterviewer = false">
                      Close
                    </v-btn>
                    <v-btn
                      color="rgb(21 72 124)"
                      dark
                      v-if="allowConfirm"
                      class="ma-2"
                      :loading="loading"
                      :disabled="loading"
                      @click="
                        confirmInterviewer();
                        loading = true;
                        dialogInterviewer = false;
                      "
                    >
                      Confirm
                      <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                      </template>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-app-bar>
            <ag-grid-vue
              style="height: 497px; font-size: 16px;"
              class="ag-theme-balham center-box elevation-2 caseAssignmentGrid"
              :columnDefs="rightColumnDefs"
              :rowData="dailyTasksData"
              :gridOptions="gridOptionsCases"
              :enableCellChangeFlash="true"
              :rowSelection="rowSelection"
              @grid-ready="onGridReady"
              rowHeight=30
            ></ag-grid-vue>
            <div>
              <div
                id="statusPopover"
                class="popover-content"
                v-bind:class="{
                  show: showStatusPopover,
                  hide: !showStatusPopover,
                }"
              >
                <StatusPopup
                  :studyCode="studyCode"
                  :record="record"
                  :assignStaffId="assignStaffId"
                  :region="region"
                  @refreshData="refreshData"
                  @close="showStatusPopover = false"
                ></StatusPopup>
              </div>
              <div
                id="notesPopover"
                class="popover-content"
                v-bind:class="{
                  show: showNotesPopover,
                  hide: !showNotesPopover,
                }"
              >
                <CommentsPopup
									:record="record"
									:caseCommentsList="caseCommentsList"
                  @close="showNotesPopover = false"
									@refreshData="refreshData"
                ></CommentsPopup>
              </div>
							<div
								id="multipleStatusPopover"
                class="popover-content"
                v-bind:class="{
                  show: showMultipleStatusPopover,
                  hide: !showMultipleStatusPopover,
                }"
              >
                <MultipleStatusPopUp
								:studyCode="studyCode"
								:multipleRecords="selectedRegionCases"
                :region="region"
                @close="showMultipleStatusPopover = false"
								@refreshData="refreshData"
                ></MultipleStatusPopUp>
							</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="!flag" style="margin: 2px 2px 0px;">
        <v-col md="12" class="marginZeroPaddingZero">
          <div id="allStaffLoader"></div>
          <v-card
					tile
            id="bottomRegionCard"
            style="height: 100%; background-color: rgb(21 72 124)"
          >
            <v-app-bar dense flat color="rgba(21 72 124)" height="35">
							<v-toolbar-title style="color: white">
                Region: &nbsp;
              </v-toolbar-title>
              <v-select
                v-model="region"
                :items="regionList"
                style="z-index: 1000; height: 22px; min-width: 10px; max-width: 50px; border-radius: 5px"
              ></v-select>
            </v-app-bar>
            <ag-grid-vue
              style="height: 400px; font-size: 16px;"
              class="ag-theme-balham center-box elevation-2 caseAssignmentGrid"
              :columnDefs="bottomColumnDefs"
              :rowData="allStaffData"
              :gridOptions="gridOptions"
              :rowSelection="rowSelection"
              :enableCellChangeFlash="true"
              @selection-changed="onSelectionChanged"
              @grid-ready="onGridReady"
							pagination="true"
              rowHeight=30
            ></ag-grid-vue>
          </v-card>
        </v-col>
      </v-row>
			<Footer></Footer>
    </v-flex>
  </v-layout> -->
</template>

<script>

import { authTokenService } from "@/services/authTokenService.js";
import { authService } from "@/services/authService.js";
import { AgGridVue } from "ag-grid-vue3";
import RegionSummaryTable from "@/components/RegionSummaryTable.vue";
import { caseAssignmentService } from "../services/caseAssignmentService";
import StatusPopup from "@/components/StatusPopup.vue";
import CommentsPopup from "@/components/CommentsPopup.vue";
import MultipleStatusPopUp from "@/components/MultipleStatusPopUp.vue";
import { commonService } from "@/services/common.service.js";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { STORE_CONSTANTS } from "@/common/store.constants";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AssignmentLeafletMap from "../components/AssignmentLeafletMap.vue";

export default {
  name: "assignment",
  data: () => ({
    STORE_CONSTANTS,
    myMap: null,
    rightColumnDefs: null,
    dailyTasksData: null,
    bottomColumnDefs: null,
    allStaffData: null,
    region: 1,
    regionList: [],
    regionTables: {},
    studyCode: null,
    claims: null,
    dialog: false,
    dialogInterviewer: false,
    record: null,
    caseCommentsList: [],
    showStatusPopover: false,
    showNotesPopover: false,
    showMultipleStatusPopover: false,
    multipleRecords: [{ dwellingId: 1 }, { dwellingId: 2 }],
    selectedRowData: null,
    features: null,
    staffIds: null,
    assignStaffId: null,
    assignStaffName: null,
    // loader: null,
    loading: false,
    regionLoading: false,
    allowConfirm: false,
    rowSelection: null,
    gridApi: null,
    drawer2: false,
    idStaff: null,
    regionLoading: false,
    selectedRegionCases: null,
    selectedStaffId: "",
    selectedRowIndex: -1,
    assignMapId: "assign_map_id",
    isFullScreen: false,
    assignMapMsg: "Loading...",
    APIVersion: null,
    flag: false,
    overlay: false,
  }),
  components: {
    AgGridVue,
    RegionSummaryTable,
    StatusPopup,
		CommentsPopup,
    MultipleStatusPopUp,
    Header,
    Footer,
    AssignmentLeafletMap,
  },
  beforeMount() {
    const me = this;
    this.gridOptions = {};
    this.gridOptionsCases = {};
    this.rowSelection = "single";
    this.rightColumnDefs = [
      {
        headerName: "MAP",
        field: "geoPoint",
        sortable: true,
        width: 70,
        resizable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
        cellRenderer: (params) => {
          let div = document.createElement("div");
          var img = document.createElement("img");
          img.src = require("../assets/wgmm_ico_map_gps_laptop.png");
          img.style = "width:30px; height: 30px;";
          div.addEventListener("click", (e) => {
            me.onCaseClicked(e, params);
          });

          div.appendChild(img);
          return div;
        },
      },
      {
        headerName: "DUID",
        field: "dwellingId",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
        cellRenderer: (params) => {
          let div = document.createElement("div");
          let list = document.createTextNode(params.data.dwellingId);
          div.appendChild(list);
          return div;
        },
      },
      {
        headerName: "PSU",
        field: "psu",
        width: 70,
        resizable: true,
        sortable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
      },
      {
        headerName: "STATUS",
        field: "assignStatus",
        sortable: true,
        filter: true,
        width: 130,
        resizable: true,
        cellStyle: { textAlign: "left" },
        cellRenderer: (params) => {
          let div = document.createElement("div");
          let img = document.createElement("img");
          img.src = require("../assets/eroc_icon_valid.png");
          img.style = "width:30px; height: 30px;";
          // img.style = "test-img-style";
          // commented out until fixed
          div.addEventListener("click", (e) => {
            // close any existing open popup/
            me.showStatusPopover = false;
            me.showNotesPopover = false;
            this.record = params.data;
            me.showStatusPopover = true;
            me.showNotesPopover = false;
          });
          let statusText = params.data.assignStatus;
          statusText = this.formatStatus(statusText);
          let status = document.createTextNode(statusText);
          div.appendChild(img);
          div.appendChild(status);
          return div;
        },
      },
      {
        headerName: "NOTES",
        field: "notes",
        sortable: true,
        filter: true,
        width: 100,
        resizable: true,
        cellStyle: { textAlign: "left" },
        cellRenderer: (params) => {
          const img = document.createElement("img");
          img.src = require("../assets/bubble.png");
          img.style = "width:30px; height: 30px;";
          // img.style = "test-img-style";
          // commenting out notes popup until finished
          img.addEventListener("click", (e) => {
            me.record = params.data;
            me.caseCommentsList = [];

            // trying api call here
            caseAssignmentService
              .getComments("PATH", params.data.dwellingId)
              .then(function (response) {
                if (response && response.data) {
                  me.caseCommentsList = response.data;
                  me.showNotesPopover = true;
                  me.showStatusPopover = false;
                }
              })
              .catch(function (e) {
                me.caseCommentsList = [];
                me.showNotesPopover = true;
                me.showStatusPopover = false;
                console.error(e);
              });
          });
          return img;
        },
      },
    ];
    this.bottomColumnDefs = [
      {
        headerName: "MAP",
        field: "geoPointStaff",
        sortable: true,
        filter: true,
        width: 70,
        resizable: true,
        cellStyle: { textAlign: "left" },
        cellRenderer: (params) => {
          let div = document.createElement("div");
          let img = document.createElement("img");
          img.src = require("../assets/wgmm_ico_map_interviewer_home.png");
          img.style = "width:30px; height: 30px;";
          div.appendChild(img);
          return div;
        },
      },
      // {
      //   headerName: "STAFF ID",
      //   field: "idStaff",
      //   width: 100,
      //   resizable: true,
      //   sortable: true,
      //   filter: true,
      // 	cellRenderer: (params) => {
      // 		return (params.data.staffId || "No staffID");
      //     // return params.data.caseLoadUuid;
      //   },
      // },
      {
        headerName: "STAFF ID",
        field: "staffId",
        width: 100,
        resizable: true,
        sortable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
        cellRenderer: (params) => {
          return this.formatStaffName(params.data.staffId) || "No staffName";
        },
      },
      {
        headerName: "STAFF NAME",
        field: "staffName",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
        cellRenderer: (params) => {
          return this.formatStaffName(params.data.staffName) || "No staffName";
        },
      },
      {
        headerName: "CASES",
        field: "cases",
        width: 80,
        resizable: true,
        sortable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
      },
      {
        headerName: "UTILIZATION",
        field: "utilization",
        width: 120,
        resizable: true,
        cellRenderer: (params) => {
          return this.percent(Number(params.data.utilization));
        },
        sortable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
      },
      {
        headerName: "TRAVEL TIME",
        field: "durationTravel",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
      },
      {
        headerName: "TASK TIME",
        field: "durationTask",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
        cellStyle: { textAlign: "left" },
      },
    ];

    commonService
      .getUIAndApiVersion()
      .then(function (response) {
        if (response && response.data) {
          me.APIVersion = response.data.version;
        }
      })
      .catch(function (e) {
        console.error(e);
      });
  },
  watch: {
    tables: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initStaffTable();
      }
    },
    region: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.loadSearchJson();
        this.allowConfirm = true;
        this.showStatusPopover = false;
        this.showMultipleStatusPopover = false;
      }
    },
    studyCode: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateRegionList(newValue);
      }
    },
    regionList: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        console.log(newValue);
        if(newValue.length > 0) {
          this.region = newValue[0];
        }
      }
    },
    flag: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        console.log(newValue);
        if (newValue === false) {
          this.loadSearchJson();
          this.allowConfirm = true;
        }
      }
    },
    regionLoading: function (newValue, oldValue) {
      const elem = document.getElementById("mapLoader");
      if (elem) {
        const allStaffLoadingElem = document.getElementById("allStaffLoader");
        const dailyTasksLoadingElem =
          document.getElementById("dailyTasksLoader");
        if (newValue) {
          //  show
          elem.classList.remove("maploadernoshow");
          elem.classList.add("maploader");
          if (allStaffLoadingElem) {
            allStaffLoadingElem.classList.add("universalLoader");
          }
          if (dailyTasksLoadingElem) {
            dailyTasksLoadingElem.classList.add("universalLoader");
          }
        } else {
          //don't show
          elem.classList.remove("maploader");
          elem.classList.add("maploadernoshow");
          if (allStaffLoadingElem) {
            allStaffLoadingElem.classList.remove("universalLoader");
          }
          if (dailyTasksLoadingElem) {
            dailyTasksLoadingElem.classList.remove("universalLoader");
          }
        }
      }
    },
  },
  computed: {
    regionTable: function () {
      return this.regionTables[this.region];
    },
    unassignedCaseList: function () {
      if (
        !this.regionTable.caseLoadMap ||
        !this.regionTable.caseLoadMap["Unassigned"]
      ) {
        return null;
      } else {
        return this.regionTable.caseLoadMap["Unassigned"].caseList;
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApiCases = this.gridOptionsCases.api;
    this.gridColumnApiCases = this.gridOptionsCases.columnApi;

    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created() {
    this.studyCode = this.$store.getters["study/getSelectedStudyId"];

    const me = this;
    // Subscribe to listen to mutations to the map store
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setStatusRecordToUpdate") {
        me.showStatusPopover = false;
        me.showStatusPopover = true;
        me.showNotesPopover = false;
      }

      if (
        mutation.type ===
        this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_SELECTED_CASE_IDS
      ) {
        this.selectedRegionCases = state.assignment.selectedCaseIds;
        me.showStatusPopover = false;
        me.showNotesPopover = false;
        me.showMultipleStatusPopover = true;
      }

      if (
        mutation.type ===
        this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING
      ) {
        this.regionLoading = state.assignment.isCaseAssignmentLoading;
      }
    });
  },

  // can move most methods into new assignment.service.js to reduce number of lines in this file
  methods: {
    onCaseClicked(evt, params) {
      this.$store.commit(
        this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_DWELLING_ID,
        { data: params.data.dwellingId }
      );
    },
    style(feature) {
      return {
        fillColor: "green",
        fillOpacity: 0.5,
        weight: 2,
        opacity: 1,
        color: "#ffffff",
        dashArray: "3",
      };
    },
    updateRegionList(studyCode) {
      const me = this;
      caseAssignmentService
        .getRegionList(studyCode)
        .then(function (response) {
          if (response && response.data) {
            me.flag = false;
            me.regionList = response.data;
          } else {
            me.flag = true;
          }
        })
        .catch(function (e) {
          console.error(e);
        });
    },
    formatStaffName(staffName) {
      return staffName;
    },
    formatStatus(status) {
      status = status.toLowerCase();
      let statusArray = status.split("_");
      statusArray = statusArray.map((x) => x[0].toUpperCase() + x.slice(1));
      let text = statusArray.join(" ");
      return text;
    },
    selectStudy(study) {
      this.studyCode = study;
      this.$store.commit(
        this.STORE_CONSTANTS.STUDY.MUTATIONS.WITH_NAMESPACE
          .SET_SELECTED_STUDY_ID,
        study
      );
    },
    logout() {
      authService.logout(false);
    },
    confirmRegion() {
      const me = this;
      if (this.studyCode && this.region) {
        caseAssignmentService
          .confirmRegion(this.studyCode, this.region)
          .then(function (response) {
            me.loadSearchJson();
            me.loading = false;
          })
          .catch(function (e) {
            console.error(e);
          });
      }
    },
    confirmInterviewer() {
      const me = this;
      if (this.studyCode && this.region && this.assignStaffId) {
        caseAssignmentService
          .confirmInterviewer(this.studyCode, this.region, this.assignStaffId)
          .then(function (response) {
            me.loadSearchJson();
            me.loading = false;
          })
          .catch(function (e) {
            console.error(e);
          });
      }
    },
    refreshData(updateData) {
      const me = this;
      if (updateData) {
        console.log("refreshing data...");
        this.$store.commit(
          this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_GEO_JSON,
          { data: updateData.geojson }
        );
        this.$store.commit(
          this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_TABLE_JSON,
          { data: updateData.json }
        );

        //Set the updated region info here.
        me.dailyTasksData = me.regionTables[me.region] =
          updateData.json[me.region];

        //Re-init the staff table on the bottom
        this.initStaffTable();
        this.refreshCells();

        // Check if the user has selected a row, we want to select this
        // row after the map refreshes
        if (me.selectedRowIndex !== -1) {
          setTimeout(() => {
            me.gridOptions.api.forEachNode((node) => {
              if (node.rowIndex === me.selectedRowIndex) {
                node.setSelected(true);
              }
            });
            me.selectedRowIndex = -1; // Reset to initial value...
            me.$store.commit(
              me.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING,
              { data: false }
            );
          }, 3000); // DD - this seems way too long....
        } else {
          this.$store.commit(
            me.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING,
            { data: false }
          );
        }
      }
    },
    refreshCells() {
      var params = {
        force: true,
        suppressFlash: false,
      };
      this.gridApi.refreshCells(params);
      this.gridApiCases.refreshCells(params);
    },
    onSelectionChanged(evt) {
      // console.log('onSelectionChanged...');
      this.selectedRowData = this.gridOptions.api.getSelectedRows();
      if (
        Array.isArray(this.selectedRowData) &&
        this.selectedRowData.length > 0
      ) {
        this.dailyTasksData = this.selectedRowData[0].caseList;

        this.selectedStaffId = this.assignStaffId =
          this.selectedRowData[0].staffId; // works for https://eagle.westat.com/
        this.assignStaffName = this.selectedRowData[0].staffName
          ? this.selectedRowData[0].staffName
          : "No StaffName";
        // console.log('setting staff id in store........................')
        this.$store.dispatch(
          this.STORE_CONSTANTS.ASSIGNMENT.ACTIONS.SET_STAFF_ID,
          { data: this.selectedStaffId }
        );
        // Updates the lower right hand corner of the map
        // to reflect the currently selected staff
        const div = document.getElementById("_divStaffId");
        if (div) {
          div.innerHTML = `Staff ID: ${this.selectedStaffId}`;
        }

        // Grab the selected row index here, if we unassign, reassign, etc.
        // any cases we want to show this region\staff selection after the
        // map refreshes
        const nodes = evt.api.getSelectedNodes();
        this.selectedRowIndex = nodes[0].rowIndex;
      }
    },
    initDailyTasksTable() {
      if (this.allStaffData && this.allStaffData.length > 0) {
        this.selectedRowData = this.allStaffData[0];
        this.dailyTasksData = this.selectedRowData.caseList;
        this.assignStaffId = this.allStaffData[0].staffId; // works for https://eagle.westat.com/
        this.assignStaffName = this.allStaffData[0].staffName; // works for https://eagle.westat.com/
        this.gridApiCases.refreshCells();
      }
    },
    async initialLoad() {
      await this.$store.dispatch(
        this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_TABLE_JSON,
        {
          studyCode: this.studyCode,
          region: this.region,
        }
      );
      await this.$store.dispatch(
        this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_GEO_JSON,
        {
          studyCode: this.studyCode,
          region: this.region,
        }
      );
    },
    percent(val) {
      return Number(val * 100).toFixed(0) + "%";
    },
    initStaffTable() {
      let arrayStaffsNotAssigned = [];

      const caseLoadMap = this.regionTables[this.region]
        ? this.regionTables[this.region].caseLoadMap
        : {};
      let arrayStaffsAssigned = Object.values(caseLoadMap);

      //sort by staffId descending
      arrayStaffsAssigned.sort((a, b) => {
        if (a.staffId < b.staffId) {
          return -1;
        }
        if (a.staffId > b.staffId) {
          return 1;
        }
        return 0;
      });
      this.allStaffData =
        arrayStaffsAssigned && arrayStaffsAssigned.length > 0
          ? arrayStaffsAssigned.concat(arrayStaffsNotAssigned)
          : [];
      this.initDailyTasksTable();

      // Set staff Ids
      let staffIdsForRegion = Object.keys(caseLoadMap).filter(
        (item) => item !== "Unassigned"
      );
      staffIdsForRegion = staffIdsForRegion.sort((a, b) => {
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        if (a === b) {
          return 0;
        }
      });
      this.$store.commit(
        this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_REGION_STAFF,
        { data: staffIdsForRegion }
      );
    },
    async getRegionList() {
      await caseAssignmentService.getRegionList(this.studyCode);
    },
    async loadSearchJson() {
      const me = this;
      me.overlay = true;
      this.$store.commit(
        this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING,
        { data: true }
      );

      this.$store
        .dispatch(this.STORE_CONSTANTS.ASSIGNMENT.ACTIONS.FETCH_TABLE_JSON, {
          studyCode: this.studyCode,
          region: this.region,
        })
        .then((data) => {
          me.dailyTasksData = me.regionTables[me.region] = data[me.region];
          me.selectedRowData = null;
          me.initStaffTable();
          me.refreshCells();
        })
        .catch((err) => {
          console.error(err);
          me.overlay = false;
        })
        .finally(() => {
          me.selectedRowData = null;
        });

      this.$store
        .dispatch(this.STORE_CONSTANTS.ASSIGNMENT.ACTIONS.FETCH_GEO_JSON, {
          studyCode: this.studyCode,
          region: this.region,
        })
        .then((geoData) => {
          me.overlay = false;
        })
        .catch((err) => {
          me.overlay = false;
          console.error(err);
        })
        .finally(() => {
          me.$store.commit(
            me.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING,
            { data: false }
          );
        });
    },
    updateAnalysis() {
      if (this.EagleAssignmentUpdateArray) {
        this.$store.commit(
          this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING,
          { data: true }
        );
        caseAssignmentService
          .updateAnaylsis(this.EagleAssignmentUpdateArray)
          .then(function (response) {})
          .catch(function (e) {
            console.error(e);
          });
      }
    },
    updateBatch(caseAssignmentArray) {
      const me = this;
      if (caseAssignmentArray && caseAssignmentArray.length > 0) {
        this.$store.commit(
          this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING,
          { data: true }
        );
        caseAssignmentService
          .updateCaseBatch(this.studyCode, caseAssignmentArray, this.region)
          .then(function (response) {
            if (response && response.data) {
              me.refreshData(response.data);
            }
          })
          .catch(function (e) {
            console.error(e);
          });
      }
    },
    goToValidation() {
      this.$router.push("/validation");
    },
    goToAssignment() {
      this.$router.push("/assignment");
    },
    goToUserManagment() {
      this.$router.push("/management");
    },
    onResize(event) {
      this.gridApi.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
    onUpdateStatus(evt) {
      let duid = evt.detail;
      this.record = null;

      if (this.allStaffData) {
        for (let piece of this.allStaffData) {
          if (piece.caseList) {
            for (let check of piece.caseList) {
              if (duid === check.dwellingId) {
                this.record = check;
                break;
              }
            }
          }
        }
      }

      if (this.record) {
        this.selectedStaffId = this.record.staffId;
        this.showStatusPopover = false;
        this.showStatusPopover = true;
        this.showNotesPopover = false;
      }
    },
    onUpdateComments(evt) {
      let duid = evt.detail;
      this.record = null;

      let myRecord;
      if (this.allStaffData) {
        for (let piece of this.allStaffData) {
          if (piece.caseList) {
            for (let check of piece.caseList) {
              if (duid === check.dwellingId) {
                myRecord = check;
                break;
              }
            }
          }
        }
      }

      if (myRecord) {
        // trying api call here
        this.caseCommentsList = [];

        const me = this;
        caseAssignmentService
          .getComments(this.studyCode, "" + duid)
          .then(function (response) {
            // console.log(response)
            if (response && response.data) {
              me.caseCommentsList = response.data;
              me.showNotesPopover = true;
            }
          })
          .catch(function (e) {
            console.error(e);
            me.showNotesPopover = false;
            me.showNotesPopover = true;
          });
      }
    },
  },
  directives: {
    "status-clicked-info-popup": {
      bind: function (el, binding) {
        // Define ourClickEventHandler
        const ourClickEventHandler = (event) => {
          if (el.contains(event.target) && el !== event.target) {
            // as we are attaching an click event listern to the document (below)
            // ensure the events target is outside the element or a child of it
            binding.value(event); // before binding it
          }
        };
        // attached the handler to the element so we can remove it later easily
        el.__vueClickEventHandler__ = ourClickEventHandler;

        // attaching ourClickEventHandler to a listener on the document here
        document.addEventListener("status", ourClickEventHandler);
      },
      unbind: function (el) {
        // Remove Event Listener
        document.removeEventListener("status", el.__vueClickEventHandler__);
      },
    },
    "comments-clicked-info-popup": {
      bind: function (el, binding) {
        // Define ourClickEventHandler
        const ourClickEventHandler = (event) => {
          if (el.contains(event.target) && el !== event.target) {
            // as we are attaching an click event listern to the document (below)
            // ensure the events target is outside the element or a child of it
            binding.value(event); // before binding it
          }
        };
        // attached the handler to the element so we can remove it later easily
        el.__vueClickEventHandler__ = ourClickEventHandler;

        // attaching ourClickEventHandler to a listener on the document here
        document.addEventListener("comments", ourClickEventHandler);
      },
      unbind: function (el) {
        // Remove Event Listener
        document.removeEventListener("comments", el.__vueClickEventHandler__);
      },
    },
  },
};
</script>

<style scoped>
#firstRow {
  height: 700px;
}
#mapid {
  height: 700px;
  /* height: 43vh; */
  /* height: 50vh; */
  /* margin: 10px 10px 10px 10px; */
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 1px solid rgb(21 72 124);
}
#bottomRegionCard {
  border-left: 1px solid rgb(21 72 124);
  border-right: 1px solid rgb(21 72 124);
  border-bottom: 1px solid rgb(21 72 124);
}
#regionSummaryCard {
  /* border-left: 1px solid rgb(21 72 124); */
  border-right: 1px solid rgb(21 72 124);
}
#staffCard {
  /* border-left: 1px solid rgb(21 72 124); */
  border-bottom: 1px solid rgb(21 72 124);
  border-right: 1px solid rgb(21 72 124);
}
.v-select {
  color: red;
}

.v-app-bar {
  color: "orange";
}
.center {
  text-align: center;
}
.test-img-style {
  height: 500px;
  width: 5px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.loader-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #eeeeee85;
  z-index: 1000000;
  padding: 100px 0;
}
.popover-content {
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: #f5f5f5;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 14px;
  padding-right: 14px;
  text-align: start;
  border: 1px solid rgb(21, 72, 124);
  /* border-radius: 2%; */
  font-size: 12px;
  z-index: 50000;
  width: 500px;
  box-shadow: 3px 3px 5px 6px rgb(0, 0, 0, 0.2);
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.staff-id-container {
  border: 2px solid;
  border-radius: 5px;
  height: 200px;
  width: 200px;
}
.marginZeroPaddingZero {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
}

.maploader {
  z-index: 1000000000;
  color: blue;
  background-color: rgb(21, 72, 124 / 25%);
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
}

.maploadernoshow {
  z-index: 1000000000;
  color: blue;
  background-color: rgb(21, 72, 124 / 25%);
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  display: none;
}

.bottom-right {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.clock {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: #e0e0e0;
  margin: 10px auto;
  border: 5px solid rgb(21, 72, 124);
  position: relative;
  box-shadow: 0 5px 0 0 rgba(0, 0, 0, 0.3), inset 0 5px 0 0 rgba(0, 0, 0, 0.3),
    inset 0 0 0 34px #e0e0e0;
}

.clock:after {
  content: "";
  width: 2px;
  height: 40px;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: inset 0 2px 0 0 #fff, inset 0 20px 0 0 rgb(21, 72, 124);
  animation: clock 0.5s linear infinite;
}

.clock:before {
  content: "";
  width: 2px;
  height: 30px;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: inset 0 2px 0 0 #fff, inset 0 15px 0 0 rgb(21, 72, 124);
  animation: clockb 6s linear infinite;
}

@keyframes clock {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes clockb {
  100% {
    transform: rotate(360deg);
  }
}

.universalLoader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #17677d76;
  z-index: 100;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.cardText {
  font-size: 20px;
  padding-left: 5px;
}
</style>
